import { Button } from '@calizahq/react-components-v2'
import React, { FC } from 'react'

import { BottomSheet } from '@/components'
import { useToggle } from '@/hooks'

import { CreateAgentForm } from '../CreateAgent/CreateAgentForm'

type FilterBarProps = {
  refetchOnSuccess: () => void
}

export const FilterBar: FC<FilterBarProps> = ({ refetchOnSuccess }) => {
  const { isShown: modalShown, toggle: modalToggle } = useToggle()

  return (
    <>
      <div className="flex flex-col items-center pb-6 md:flex-row-reverse md:justify-end lg:flex-row">
        <div className="mr-2 flex w-full flex-row items-center gap-2 md:mr-4 md:justify-end md:gap-3 lg:flex-wrap">
          <Button className="mr-4 bg-action-primary" onClick={modalToggle} size="small">
            Add Agent
          </Button>
        </div>
      </div>
      <BottomSheet isVisible={modalShown} mobileFullHeight={true} onClose={modalToggle}>
        <CreateAgentForm refetchOnSuccess={refetchOnSuccess} toggle={modalToggle} />
      </BottomSheet>
    </>
  )
}
